import React from "react"
import PropTypes from "prop-types"
import { SvgNormalizer } from "@asphalt-react/svg-normalizer"

import styles from "./navitem-icon.module.css"
import { navItemIconSize } from "./values.js"

export const NavItemIcon = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <div {...rest} className={styles.NavItemIcon}>
      <SvgNormalizer dimension={navItemIconSize}>{children}</SvgNormalizer>
    </div>
  )
}

NavItemIcon.displayName = "NavItemIcon"

NavItemIcon.propTypes = {
  /**
   * Icon to enhance the nav item's caption. Accepts SVG.
   */
  children: PropTypes.node,
}
